module.exports = __webpack_public_path__ + "media/videos/autopilot/autopilot-promo-9990c0e372b38240fb817a87e737bd35.mp4";